import { z } from '@willow/shared-web';
import { PORTAL_PASSWORD_MAX_LENGTH, PORTAL_PASSWORD_MIN_LENGTH } from '@willow/types-iso';

export const authEmailSchema = z
  .string()
  .trim()
  .min(1, { error: 'Enter your email address' })
  .refine((value) => z.email().safeParse(value).success, { error: 'Enter a valid email address' });

// Mirrors the server rule in @willow/shared-node's passwordPolicy (§10.2). No composition rules.
export const authNewPasswordSchema = z
  .string()
  .min(PORTAL_PASSWORD_MIN_LENGTH, { error: `Use at least ${PORTAL_PASSWORD_MIN_LENGTH} characters` })
  .max(PORTAL_PASSWORD_MAX_LENGTH, { error: `Use at most ${PORTAL_PASSWORD_MAX_LENGTH} characters` });
